import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import SvgIcon from 'react-icons-kit';
import swal from 'sweetalert';
import moment from 'moment';
import $ from 'jquery';

var Config = require('../../config');

class ModalPersonSearch extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onCheck = this.onCheck.bind(this);
		this.selectPerson = this.selectPerson.bind(this);

		this.state = {
		    show: false,
		    title:"",
		    type:"",

		    paterno:"",
		    materno:"",
		    nombre:"",
		    documento:"",
			unit:"",
			expedient:"",

		    list:[],
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	handleClose() {
		this.setState({ 
			show: false, 
			title:"", 
			type:"",
			paterno:"",
		    materno:"",
		    nombre:"",
		    documento:"",
			list:[],
			expedient:"",
		});
	}

	handleShow(title, type) {
		this.setState({show:true, title:title, type:type});
		console.log(type)
		setTimeout(()=>{
			document.getElementById('paterno').focus();
		}, 500);
		
	}

	onSearch(){
		var error = '';
			
			
			if(this.state.documento === "" && (this.state.nombre === "" && this.state.paterno === "")){
				error = 'Debe Ingresar número de documento ó nombre y primer apellido';				

				if(this.state.type === 'patients'){
					if(this.state.expedient !== ""){
						error = '';
					}
				}
			}

			if(error === ""){
				this.props.waiting.handleShow('Cargando...');
				var urlApi = 'person/search_by_type?lastname1='+this.state.paterno+'&lastname2='+this.state.materno+
					'&names='+this.state.nombre+'&document_number='+this.state.documento+
					'&number='+this.state.expedient+'&type='+this.state.type;

				if(this.props.location !== undefined){
					if(this.props.location.pathname === '/kardex_hemovigilance'){
						urlApi = 'unit_delivered/search_transfusion?names='+this.state.nombre+'&lastname1='+this.state.paterno+
										'&lastname2='+this.state.materno+'&unit_number='+this.state.unit;
					}
				}
					
				fetch(Config.default.apiGateway.URL+urlApi,{
					method:'GET',
					headers:new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						response.map((res)=>{
							res.check = false;
							if(this.state.type === 'donors'){
								res.id = res.donor_id;
							}else{
								res.id = this.props.location !== undefined ?
											this.props.location.pathname === '/kardex_hemovigilance' ? res.id : res.patient_id
										: res.person_id;
							}
						});

						this.setState({
							list:response,
							paterno:"",
						    materno:"",
						    nombre:"",
							documento:"",
							expedient:""
						});
					}
				})
			}else{
				swal('Error', error, 'error');	
			}
	}

	onCheck(e, i){
		var list = this.state.list;

		list.map((l, j)=>{
			if(j === i){
				l.check = e.target.checked ? true : false;
			}else{
				l.check = false;
			}
		});

		this.setState({list:list});

	}

	selectPerson(){
		var value = [];
		this.state.list.map((l)=>{
			if(l.check){
				value.push(l);
			}
		});

		if(value.length > 0){
			
			if(this.state.type === 'donors'){
				if(this.props.location !== undefined){
					if(this.props.location.pathname === '/fusion/donor'){
						var name = value[0].lastname1+' '+value[0].lastname2+' '+value[0].names;
						this.props.waiting.handleShow('Cargando...');
						this.props.search(value);
					}else{
						this.props.waiting.handleShow('Cargando...');

						this.props.updatePerson(value);	

						this.handleClose();
					}
				}else{
					this.props.waiting.handleShow('Cargando...');

					this.props.updatePerson(value);	

					this.handleClose();
				}
					
					
			}else{
				var name = value[0].lastname1+' '+value[0].lastname2+' '+value[0].names;
				this.props.waiting.handleShow('Cargando...');
				
				if(this.props.location !== undefined){
					if(this.props.location.pathname === '/kardex_hemovigilance'){
						this.props.search(value[0].id);
					}else{
						this.props.search(value);	
					}
				}else{
					this.props.search(value);	
				}
					
			}

			this.handleClose();
		}else{
			swal('Error', 'Debe seleccionar un elemento', 'error');
		}			
		

	}

	

	render(){
		const { t } = this.props;
		
		return(
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose} className="modal-history">
		       	<Modal.Header closeButton>
		        	<Modal.Title>Busqueda de {this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group form-modal">
		        			<div className="col-xs-12 col-sm-2">
		        				<span className="span-min">Apellido P.</span>
		        				<input type="text" name="paterno" id="paterno" value={this.state.paterno} onChange={this.handleChange}
		        					className="form-control"  />
		        			</div>
		        			<div className="col-xs-12 col-sm-2">
		        				<span className="span-min">Apellido M.</span>
		        				<input type="text" name="materno" id="materno" value={this.state.materno} onChange={this.handleChange}
		        					className="form-control" />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Nombre(s)</span>
		        				<input type="text" name="nombre" id="nombre" value={this.state.nombre} onChange={this.handleChange}
		        					className="form-control" />
		        			</div>
		        			{this.state.type === 'donors' ? 
		        				<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">No. Documento</span>
			        				<input type="text" name="documento" id="documento" value={this.state.documento} onChange={this.handleChange}
			        					className="form-control" />
			        			</div>
		        			:null}
		        			{this.props.location !== undefined ?
								this.props.location.pathname === '/kardex_hemovigilance' ?
								<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">No. Unidad</span>
			        				<input type="text" name="unit" id="unit" value={this.state.unit} onChange={this.handleChange}
			        					className="form-control" />
			        			</div>
								:null
							:null}
							{this.state.type === 'patients' || this.state.type === 'donors' ?
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">
										{this.state.type === 'patients' ? 'Expediente' : 'No. Donador'}
									</span>
									<input type="text" name="expedient" id="expedient" value={this.state.expedient} onChange={this.handleChange}
										className="form-control" />
								</div>
							: null}
			        			
		        			<div className="col-xs-12 col-sm-1" style={{marginTop:'18px'}}>
		        				<button className="btn btn-info" onClick={this.onSearch}>
		        					Buscar
		        				</button>
		        			</div>
		        		</div>

		        		<div className="col-xs-12">
		        			<table style={{width:'100%'}}>
		        				<thead>
							  		<tr>
							    		<td style={{padding:0}}>
							       			<Table responsive style={{marginBottom:0}}>
							       				<thead>
								         			<tr>
											            <th style={{width:'46px'}}></th>
						        						<th style={{width:'133px'}}>Apellido P</th>
						        						<th style={{width:'132px'}}>Apellido M</th>
						        						<th style={{width:'174px'}}>Nombre(s)</th>
						        						<th style={{width:'94px'}}>F. Nacimiento</th>
						        						<th style={{width:'94px'}} hidden={this.state.type !== 'donors'}>T. Documento</th>
						        						<th style={{width:'150px'}} hidden={this.state.type !== 'donors'}>No. Documento</th>
						        						<th style={{width:'150px'}} 
						        							hidden={this.props.location !== undefined ?
						        								this.props.location.pathname !== '/kardex_hemovigilance'
						        							:true}>
						        							No. Unidad
						        						</th>
														<th style={{width:'100px'}}>{this.state.type === 'patients' ? 'Expediente' : 'No. Donador'}</th>
										        	</tr>
										        </thead>
										    </Table>
							       
							    		</td>
						  			</tr>
						  		</thead>
							  	<tbody>
							  		{this.state.list.length > 0 ?
							  			<tr>
									    	<td>
									    		<div style={{width:'100%', height:'220px', overflow:'auto'}}>
									    			<table className="table">
									    				<tbody>
									    				{this.state.list.map((l, i)=>(
							        						<tr key={i}>
								        						<td style={{width:'50px'}}>
								        							<input type="checkbox" value={l.check} onChange={(e)=>this.onCheck(e, i)}
								        								checked={l.check} />
								        						</td>
								        						<td style={{width:'150px'}}>{l.lastname1}</td>
								        						<td style={{width:'150px'}}>{l.lastname2}</td>
								        						<td style={{width:'200px'}}>{l.names}</td>
								        						<td style={{width:'100px'}}>{l.birthday !== null ? moment(l.birthday).format('DD/MM/YYYY') : ''}</td>
								        						<td style={{width:'110px'}} hidden={this.state.type !== 'donors'}>{l.document_type}</td>
								        						<td style={{width:'150px'}} hidden={this.state.type !== 'donors'}>{l.document_number}</td>
								        						<td style={{widtd:'150px'}} 
								        							hidden={this.props.location !== undefined ?
							        								this.props.location.pathname !== '/kardex_hemovigilance'
							        							:true}>
							        								{l.unit_number}
							        							</td>
																<td style={{width:'100px'}}>{this.state.type === 'donors' ? l.donor_number : l.patient_number}</td>
								        					</tr>
							        					))}
							        					</tbody>
									    			</table>
									    		</div>
									    	</td>
									    </tr>
							  		:null}
									  	
							    </tbody>
		        			</table>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.select')}  onClick={this.selectPerson}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalPersonSearch) 